import './lle_details.css';
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, APPLICATION_ADDRESS_EVIDENCE, EXISTING_OCC, GENDER, HIGHEST_QUALIFICATION, LLE_TRADE_LICENSE, MOA_REGISTRATION_CERTIFICATE, SALUTATION, LINKS } from '../../../../common/constants';
import { ADDRESS_ERROR, APPLICANT_ERROR, CONTACT_PERSON_FIRST_NAME_ERROR, MOBILE_NO_ERROR, PINCODE_NO_ERROR, SEARCH_ICON_ERROR, VALID_NAME_OF_APPLICANT, VALID_NAME_OF_APPLICANT_ERROR, INVALID_OTP_ERROR } from '../../../../common/constants';
import resolveIcon from "../../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { Container, FormGroup, FormControlLabel, Checkbox, Card, CardContent, ToggleButton, ToggleButtonGroup, Stack, Box, Typography, Grid, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { Button } from '@mui/material';
import BackButton from '../../../../common/backButton';
import { isValidName, maxNameLength, VALIDATION, nameValidation, typeNumberValid, emailValidation } from '../../../../common/commonValidations';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { ArrowForwardIosIcon, CloseIcon } from '../../../../common/icons';
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, emailUrnPassMaxLength, mobileNoMaxLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength} from '../../../../common/commonValidations';

const LLEDetails = () => {
    const { t, i18n } = useTranslation();
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [backButtonData, setBackButtonData] = useState();
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [otpValue, setOtpValue] = useState()
    const [prevScreenData, setPrevScreenData] = useState();
    const [checkTermChecked, setCheckTermChecked] = useState(false);
    const [checkTermDisable, setCheckTermDisable] = useState(false);
    const initialData = {
        fullName: '',
        mobileNo: '',
        emailId: '',
        companyType: '',
        pincode: '',
        contactPersonFirstName: '',
        contactPersonMiddleName: '',
        contactPersonLastName: '',
        contactPersonSalutation: 'Mr',
        contactPersonGender: 'Male',
        residenceProof: '',
        registrationNo: '',
        educationQualification: '',
        netWorth: '',
        workingCapital: '',
        typeOfOcc: '',
        address: '',
        revenueCircle: '',
        blockName: '',
        state: '',
        district: ''

    }
    const [details, setDetails] = useState(initialData);
    const navigate = useNavigate();
    const location = useLocation();
    const initialError = {
        fullNameError: '',
        contactPersonNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        emailIdError: '',
        addressError: '',
        residenceProofError: '',
        registrationNoError: '',
        educationQualificationError: '',
        netWorthError: '',
        workingCapitalError: '',
        typeOfOccError: '',
        OTPError: '',
        OTPSentError: '',
        acceptTermError: ''
    }
    const [errorMessage, setErrorMessage] = useState(initialError);
    useEffect(() => {
        setPrevScreenData(location?.state?.data)
        // setDocumentDetailsArr(location.state.data?.documents)
        // setSelectedApplicant(location?.state?.data?.applicantType);
        if (location?.state?.data && location?.state?.data.mobileValidation == "false") {
            setVerifyMobileNo(false);
            setMobileOTPValidated(false);
        }

    }, [prevScreenData]);

    const clear = (e) => {
        setDetails(initialData);
        setMobileOTPValidated(false);
        setCheckTermChecked(false);
        setCheckTermDisable(false);
        setOtpHidden(true);
        setVerifyMobileNo(false);
        setErrorMessage(initialError);
    }
    const handleCheckboxTerms = (e) => {
        if (e.target.checked) {
            e.preventDefault();
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setOtpValue("");
            if (isValidMobileNumber(details.mobileNo)) {
                sendOTP(details.mobileNo, callBackMobileValidation);
                setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
                setCheckTermChecked(false);
            }
        }
    }
    const getUpdatedAddressData = (data) => {
        setDetails({
            ...details,
            pincode: data.pincode,
            state: data.pincodeState,
            district: data.pincodeDistrict,
            subDivision: data.pincodeSubDivision,
            revenueCircle: data.selectedRevenueCircle,
            blockName: data.selectedBlockName,
        });
        setErrorMessage({...errorMessage, pincodeError: ""})
    }
    const handleChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails({ ...details, blockName: e.target.value });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails({ ...details, revenueCircle: e.target.value, });
        }
    }
    // const onClickVerifyMobileNo = (e) => {
    //     e.preventDefault();
    //     setVerifyMobileNo(true);
    // }
    // const isValidEmail = (email) => {
    //     return /\S+@\S+\.\S+/.test(email);
    // }
    // const onOtpChange = (e) => {
    //     const limit = 4;
    //     setOtpValue(e.target.value.slice(0, limit))
    // }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", OTPError: "", acceptTermError: "" })
            setVerifyMobileNo(true);
            setOtpHidden(false);
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "", OTPError: "", mobileNoError: "", acceptTermError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    useEffect(() => {
        setBackButtonData(location?.state?.data)
        if (backButtonData) {
            setDetails({
                fullName: backButtonData.name,
                mobileNo: backButtonData.mobileNo,
                emailId: backButtonData.emailId,
                companyType: backButtonData.companyType,
                pincode: backButtonData.pincode,
                contactPersonFirstName: backButtonData.contactPersonFirstname,
                contactPersonMiddleName: backButtonData.contactPersonMiddlename,
                contactPersonLastName: backButtonData.contactPersonLastname,
                contactPersonSalutation: backButtonData.contactPersonSalutation,
                contactPersonGender: backButtonData.contactPersonGender,
                address: backButtonData.address,
                revenueCircle: backButtonData.revenueCircle,
                blockName: backButtonData.blockName,
                state: backButtonData.state,
                district: backButtonData.district,
                subDivision: backButtonData.subDivision,
                acceptedTerms: backButtonData.acceptedTerms
            });
            setSelectedApplicant(backButtonData.applicantType)
            if (location?.state?.data && location?.state?.data.mobileValidation == false) {
                setVerifyMobileNo(false);
                setMobileOTPValidated(false);
            }
            else {
                setOtpValue(backButtonData.otp);
                setMobileOTPValidated(true);
            }
            if (backButtonData.acceptedTerms) {
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
        }
    }, [backButtonData]);

  const handleChange = (e) => {

  if (e.target.name === "fullName") {

    // 1) Clean + limit:

    const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9&/ ]/g, "").slice(0, 100);

    // 2) Save cleaned value only once:

    setDetails({

      ...details,

      [e.target.name]: cleanedValue

    });

    // 3) Validate cleaned value:

    if (cleanedValue.length > 0) {

      const Fullname_regex = /^[a-zA-Z0-9 ]+$/;

      if (!Fullname_regex.test(cleanedValue)) {

        setErrorMessage({

          ...errorMessage,

          fullNameError: "Please provide valid Name"

        });

      } else {

        setErrorMessage({

          ...errorMessage,

          fullNameError: ""

        });

      }

    } else {

      setErrorMessage({

        ...errorMessage,

        fullNameError: "Please enter Name of Applicant"

      });

    }

  } else {

    // For other fields, normal update:

    setDetails({

      ...details,

      [e.target.name]: e.target.value

    });

  }


        if (e.target.name === "address") {
            const limit = 300;
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, limit)) })
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })
        }

        if (e.target.name === "residenceProof") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, residenceProofError: "" })
            } else {
                setErrorMessage({ ...errorMessage, residenceProofError: "Please enter Residence Proof" })

            }
        }
        if (e.target.name === "registrationNo") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, registrationNoError: "" })
            } else {
                setErrorMessage({ ...errorMessage, registrationNoError: "Please enter Registration/Incorporation No." })

            }
        }
        if (e.target.name === "educationQualification") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, educationQualificationError: "" })
            } else {
                setErrorMessage({ ...errorMessage, educationQualificationError: "Please enter Highest Educational Qualification" })

            }
        }
        if (e.target.name === "netWorth") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, netWorthError: "" })
            } else {
                setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" })

            }
        }
        if (e.target.name === "workingCapital") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, workingCapitalError: "" })
            } else {
                setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" })

            }
        }
        if (e.target.name === "typeOfOcc") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, typeOfOccError: "" })
            } else {
                setErrorMessage({ ...errorMessage, typeOfOccError: "Please enter Type of Business/Occupation" })

            }
        }

        if (e.target.name === "emailId") {
            if ((e.target.value).length > 0) {
                if (emailValidation(e.target.value.slice(0, 50))) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "contactPersonFirstName") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                const Firstname_regex = /^[a-zA-Z]+$/;
                if (!((e.target.value).match(Firstname_regex))) {
                    setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" })
                } else setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name of contact person" })

            }
        }
        if (e.target.name === "contactPersonMiddleName") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            const Middlename_regex = /^[a-zA-Z]+$|^$/;
            if (!((e.target.value).match(Middlename_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "Please provide valid Name" })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "" })
            }

        }
        if (e.target.name === "contactPersonLastName") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            const Lastname_regex = /^[a-zA-Z]+$|^$/;
            if (!((e.target.value).match(Lastname_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonLastNameError: "Please provide valid Name" })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonLastNameError: "" })
            }

        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if ((!details.fullName)) {
            setErrorMessage({ ...errorMessage, fullNameError: APPLICANT_ERROR });
            return;
        }
        else if (!details.contactPersonFirstName) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR });
            return;
        }
        else if (!details.contactPersonFirstName) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR });
            return;
        }
        else if (!details.mobileNo) {
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            return;
        }
        else if (!details.emailId || !isValidEmail(details.emailId)) {
            setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address " });
            return;
        }
        else if (!details.address) {
            setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR });
            return;
        }
        else if ((details.pincode).length < 6) {
            setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR })
            return;
        }
        else if (!details.state) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            return;
        }
        else if (!checkTermChecked) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
            return false;
        }
        else if (!mobileOTPValidated && verifyMobileNo) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
            return false;
        }
        submitLLEDetails();

    };

    const OnPrevious = () => {
        const dataForApi = {
            "name": details.fullName,
            "contactPersonFirstname": details.contactPersonFirstName,
            "contactPersonMiddlename": details.contactPersonMiddleName,
            "contactPersonLastname": details.contactPersonLastName,
            "contactPersonGender": details.contactPersonGender,
            "contactPersonSalutation": details.contactPersonSalutation,
            "mobileNo": details.mobileNo,
            "emailId": details.emailId,
            "address": details.address,
            "district": details.district,
            "state": details.state,
            "pincode": details.pincode,
            "applicantType": selectedApplicant,
            "revenueCircle": details.revenueCircle,
            "blockName": details.blockName
        }
        navigate("/llemandatorypage", { state: { data: dataForApi } });
    }
    const submitLLEDetails = () => {
        const dataForApi = {
            ...prevScreenData,
            "name": details.fullName,
            "contactPersonFirstname": details.contactPersonFirstName,
            "contactPersonMiddlename": details.contactPersonMiddleName,
            "contactPersonLastname": details.contactPersonLastName,
            "contactPersonGender": details.contactPersonGender,
            "contactPersonSalutation": details.contactPersonSalutation,
            "mobileNo": details.mobileNo,
            "emailId": details.emailId,
            "address": details.address,
            "district": details.district,
            "state": details.state,
            "pincode": details.pincode,
            "applicantType": selectedApplicant,
            "revenueCircle": details.revenueCircle,
            "blockName": details.blockName,
            "otp": otpValue,
            "isOtpValidated": true,
            "acceptedTerms": checkTermChecked


        }
        navigate(getLocalStorageItem('id_token') ? "/registrationHome/preregistration/lledetailsScreenTwo" : "/preregistration/lledetailsScreenTwo", { state: { data: dataForApi } });
    }

    const onApplicantClick = (e) => {
        setSelectedApplicant(e.target.value)
        e.preventDefault()
        // if (applicantSelected === 'Individual') {
        //     setSelectedApplicant('Individual')
        // } else if (applicantSelected === 'SHG/Co-opetative') {
        //     setSelectedApplicant('SHG/Co-opetative')
        // } else if (applicantSelected === 'Firm/Enterprise') {
        //     setSelectedApplicant('Firm/Enterprise')
        // }
    }



    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG04</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} navigateTo="/webRegSidebar" />
                    <Typography variant="h5" gutterBottom>
                        {t('preReg.lle')} {t('preReg.pre-registration')}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            {t('preReg.applicantGeneralInfo')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.fullNameError}
                                            helperText={errorMessage.fullNameError}
                                            type="text"
                                            label={t('preReg.applicantName')}
                                            inputProps={{
                                                maxLength: 100,
                                                pattern: "[A-Aa-z0-9&/]*",
                                            }}

                                            name="fullName"
                                            value={details.fullName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.fullName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.contactPersonDetails')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                name='contactPersonSalutation'
                                                value={details.contactPersonSalutation}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                                                {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                            {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonNameError}
                                            helperText={errorMessage.contactPersonNameError}
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.firstname')}
                                            name="contactPersonFirstName"
                                            value={details.contactPersonFirstName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonFirstName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.middlename')}
                                            name="contactPersonMiddleName"
                                            value={details.contactPersonMiddleName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            label={t('preReg.lastname')}
                                            name="contactPersonLastName"
                                            value={details.contactPersonLastName}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.contactPersonLastname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                name='contactPersonGender'
                                                value={details.contactPersonGender}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                                                {GENDER.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            name="mobileNo"
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()}
                                            disabled={mobileOTPValidated} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                        {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                            <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                    </Grid>
                                    {/*{verifyMobileNo &&*/}
                                    {/*    <Grid item xs={3}>*/}
                                    {/*        <TextField*/}
                                    {/*            type="number"*/}
                                    {/*            onChange={(e) => onOtpChange(e)}*/}
                                    {/*            value={otpValue}*/}
                                    {/*            label={t('preReg.otp')}*/}
                                    {/*            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()} />*/}
                                    {/*    </Grid>*/}
                                    {/*}*/}
                                    {/*<Grid item xs={12}>*/}
                                    {/*    {verifyMobileNo === true ?*/}
                                    {/*        <div>*/}
                                    {/*            <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend otp</a></div>*/}
                                    {/*        : mobileOTPValidated === true ? <div className="commonVerifyText" hidden={!mobileOTPValidated} ><a href="#" style={{ marginLeft: "4vw" }}>Verified</a>*/}
                                    {/*            <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :*/}
                                    {/*            <button className="commonVerifyText" style={{ marginLeft: "0vw", float: "right" }} onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>*/}
                                    {/*    }*/}
                                    {/*</Grid>*/}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                        inputProps={{
                                                maxLength: emailUrnPassMaxLength,
                                                style: { textTransform: "none" }
                                            }}
                                            error={errorMessage?.emailIdError}
                                            helperText={errorMessage?.emailIdError}
                                            required
                                            type="text"
                                            label={t('main.email')}
                                            name="emailId"
                                            value={details.emailId}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            error={errorMessage?.addressError}
                                            helperText={errorMessage?.addressError}
                                            required
                                            type="text"
                                            label={t('main.address')}
                                            name="address"
                                            value={details.address}
                                            multiline
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                                            <BadgeComponent currentLength={details?.address?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                    revenueNotRequired={true}
                                        pincode={details?.pincode}
                                        state={details?.state}
                                        district={details?.district}
                                        revenueCircle={details?.revenueCircle}
                                        blockName={details?.blockName}
                                        onHandleCallback={getUpdatedAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleChangeSelect}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent></Card>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL.</label></>} ></FormControlLabel>
                        </FormGroup>
                        <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        {verifyMobileNo &&

                            <TextField fullWidth
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                onKeyDown={(evt) => typeNumberValid(evt)}
                                onChange={(e) => onOtpChange(e)}
                                label={t('preReg.otp')}
                                value={otpValue} />

                        }
                        {verifyMobileNo === true &&
                            <div>
                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        }
                    </Grid>
                </Grid>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100, marginRight: 1 }} variant="outlined" onClick={(e) => clear(e)} startIcon={<CloseIcon />}>{t('preReg.clear')}</Button>
                    <Button disabled={!mobileOTPValidated} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSubmit(e)} endIcon={<ArrowForwardIosIcon />}>{t('preReg.next')}</Button>
                </Box>
            </Container>
        </>
    );
}



export default LLEDetails;
